(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["budget-ladder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointerover', (e) => {
    const row = e.target.closest('[data-ladder] [data-row]'); if (!row) return;
    const root = row.closest('[data-ladder]');
    root.querySelectorAll('[data-row]').forEach((r) => r.classList.toggle('is-active', r === row));
    root.querySelectorAll('[data-pv]').forEach((p) => p.classList.toggle('is-active', p.dataset.pv === row.dataset.row));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-tabs] [data-tab]'); if (!t) return;
    const root = t.closest('[data-tabs]');
    root.querySelectorAll('[data-tab]').forEach((b) => { const on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    root.querySelectorAll('[data-panel]').forEach((p) => {
      const on = p.dataset.panel === t.dataset.tab; p.hidden = !on;
      if (on) { p.querySelectorAll('[data-reveal]').forEach((r) => r.classList.add('is-in')); p.dispatchEvent(new CustomEvent('ssss:content', { bubbles: true })); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-index]'); if (!root) return;
    const tiles = [...root.querySelectorAll('.brand-tile')];
    const input = root.querySelector('[data-index-filter]');
    const az = root.querySelector('[data-index-az]');
    const empty = root.querySelector('[data-index-empty]');
    const letters = [...new Set(tiles.map((t) => t.dataset.letter))].sort();
    let letter = '';
    letters.forEach((l) => { const b = document.createElement('button'); b.type = 'button'; b.textContent = l; b.dataset.l = l; az.appendChild(b); });
    const apply = () => {
      const q = (input.value || '').trim().toLowerCase(); let n = 0;
      tiles.forEach((t) => { const ok = (!q || t.dataset.name.includes(q)) && (!letter || t.dataset.letter === letter); t.hidden = !ok; if (ok) { n++; t.classList.add('is-in'); } });
      empty.hidden = n > 0;
    };
    input.addEventListener('input', apply);
    az.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      letter = letter === b.dataset.l ? '' : b.dataset.l;
      az.querySelectorAll('button').forEach((x) => x.classList.toggle('is-active', x.dataset.l === letter));
      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root._pdp) return; root._pdp = true;
      const $ = (s) => root.querySelector(s), $$ = (s) => [...root.querySelectorAll(s)];
      const data = JSON.parse($('[data-product-json]').textContent);
      const money = (c) => (window.SSSSUtil ? SSSSUtil.money(c) : (c / 100).toFixed(2));

      /* media switching */
      const show = (key) => {
        $$('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.panel === key));
        $$('[data-show]').forEach((t) => { const on = t.dataset.show === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        const v = root.querySelector(`[data-panel="${key}"] video`); v && v.play && v.play().catch(() => {});
      };
      root.addEventListener('click', (e) => {
        const t = e.target.closest('[data-show]'); if (t) show(t.dataset.show);
        const z = e.target.closest('[data-zoom]');
        if (z) {
          const layer = $('[data-zoom-layer]'), img = $('[data-zoom-img]');
          img.src = z.dataset.zoom; layer.hidden = false; document.body.classList.add('is-locked');
          requestAnimationFrame(() => { layer.scrollTop = (layer.scrollHeight - layer.clientHeight) / 2; layer.scrollLeft = (layer.scrollWidth - layer.clientWidth) / 2; });
        }
        if (e.target.closest('[data-zoom-layer]')) { $('[data-zoom-layer]').hidden = true; document.body.classList.remove('is-locked'); }
      });

      /* quantity */
      root.addEventListener('click', (e) => {
        const b = e.target.closest('[data-step]'); if (!b) return;
        const input = b.parentElement.querySelector('input');
        input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.step));
      });

      /* variants */
      const radios = $$('[data-option-index]');
      const update = () => {
        const sel = []; radios.forEach((r) => { if (r.checked) sel[Number(r.dataset.optionIndex)] = r.value; });
        const v = data.variants.find((x) => x.options.every((o, i) => o === sel[i]));
        $$('[data-option-label]').forEach((l) => { l.textContent = sel[Number(l.dataset.optionLabel)] || ''; });
        // availability hints
        radios.forEach((r) => {
          const i = Number(r.dataset.optionIndex);
          const test = sel.slice(); test[i] = r.value;
          const ok = data.variants.some((x) => x.available && x.options.every((o, j) => o === test[j]));
          r.closest('label').classList.toggle('is-unavailable', !ok);
        });
        const atc = $('[data-atc]'), label = $('[data-atc-label]'), bb = root.querySelector('[data-buybar-btn]');
        if (!v) { atc.disabled = true; label.textContent = 'Unavailable'; return; }
        $('[data-variant-id]').value = v.id;
        $('[data-price-now]').textContent = money(v.price);
        root.querySelector('[data-buybar-price]').textContent = money(v.price);
        const was = $('[data-price-was]');
        if (v.compare_at_price > v.price) { was.hidden = false; was.textContent = money(v.compare_at_price); $('[data-price-now]').classList.add('is-sale'); }
        else { was.hidden = true; $('[data-price-now]').classList.remove('is-sale'); }
        atc.disabled = !v.available; label.textContent = v.available ? 'Add to cart' : 'Sold';
        if (bb) { bb.disabled = !v.available; bb.textContent = v.available ? 'Add to cart' : 'Sold'; }
        const stock = $('[data-stock]');
        stock.classList.toggle('is-out', !v.available);
        stock.innerHTML = v.available ? '<i></i> In stock · ready to ship' : 'Sold';
        if (v.featured_media) { const key = 'm' + v.featured_media.id; if (root.querySelector(`[data-panel="${key}"]`)) show(key); }
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      };
      radios.forEach((r) => r.addEventListener('change', update));

      /* sticky buy bar */
      const atc = $('[data-atc]'), bar = root.querySelector('[data-buybar]');
      if (atc && bar) {
        new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', past); bar.setAttribute('aria-hidden', String(!past));
          bar.querySelector('button').tabIndex = past ? 0 : -1;
        }).observe(atc);
        root.querySelector('[data-buybar-btn]').addEventListener('click', () => atc.click());
      }

      /* recently viewed */
      try {
        const h = data.url.split('/products/')[1];
        const list = JSON.parse(localStorage.getItem('ssss-rv') || '[]').filter((x) => x !== h);
        list.unshift(h); localStorage.setItem('ssss-rv', JSON.stringify(list.slice(0, 12)));
      } catch (e) {}
    };
    document.querySelectorAll('[data-pdp]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-pdp]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recs')) {
    customElements.define('product-recs', class extends HTMLElement {
      connectedCallback() {
        if (this.children.length) return;
        const io = new IntersectionObserver((e) => {
          if (!e[0].isIntersecting) return; io.disconnect();
          fetch(this.dataset.url).then((r) => r.text()).then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('product-recs');
            if (fresh && fresh.innerHTML.trim()) {
              this.innerHTML = fresh.innerHTML;
              this._rail = false;
              this.dispatchEvent(new CustomEvent('ssss:content', { bubbles: true }));
            } else this.closest('section').remove();
          }).catch(() => {});
        }, { rootMargin: '400px' });
        io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
